import { HighResolutionTimespanEnum } from '@/bundles/ExternalTracking/types';
import { MapSaveImageQualityEnum } from '@/bundles/Map/types';

// mapbox fetches zoom - Math.round(zoom level + 1 (for tile size 256)), so 14.49 = 15, 14.5+ = 16
// 16 zoom level is the first paid level for Vexcel
export const MAX_FREE_VEXCEL_ZOOM = 14.49;

export const highResolutionTimespanLabels = {
  [HighResolutionTimespanEnum.months]: 'Months',
  [HighResolutionTimespanEnum.years]: 'Years',
}

export const mapSaveImageZoomQualityOffsets = {
  [MapSaveImageQualityEnum.BASE]: 0,
  [MapSaveImageQualityEnum.MEDIUM]: 1,
  [MapSaveImageQualityEnum.HIGH]: 2,
}
